export default "__VITE_ASSET__i3LC0eRA__"